import Arial from "./ARIAL.ttf";
import ArialBD from "./ARIALBD.ttf";
import ArialBDI from "./arialbi.ttf";
import { Font } from '@react-pdf/renderer';

export const RegisterArial = () => {
    Font.register({
        family: 'Arial',
        fonts: [
            { src: Arial },
            { src: ArialBD, fontWeight: 'bold' },
            { src: ArialBDI, fontWeight: 'semibold' }
        ]
    });
}
